import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { appRouterPaths } from "@/services/navigation";
import { useInvalidContactModal } from "@/services/blocking-modal";
import {
  contactsIsEditSelector,
  currentPersonSelector,
  isNewPersonSelector,
  setContactsIsEdit,
  setCurrentPerson,
} from "../../slice";
import { getDefaultActivitiesTabFormValues } from "../../Tabs/ActivitiesTab/helpers";
import { getDefaultGeneralTabInfoFormValues } from "../../Tabs/GeneralInfoTab/helpers";

export const useContactsControlButtons = ({
  tabType,
}: {
  tabType?: "generalInfo" | "activities";
}) => {
  const { executeWithConfirm } = useInvalidContactModal();

  const formApi = useFormContext();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const isEdit = useAppSelector(contactsIsEditSelector);
  const currentPerson = useAppSelector(currentPersonSelector);
  const isNewPerson = useAppSelector(isNewPersonSelector);

  const resetForm = () => {
    if (!currentPerson) {
      return;
    }

    const formValues =
      tabType === "activities"
        ? getDefaultActivitiesTabFormValues(currentPerson)
        : getDefaultGeneralTabInfoFormValues(currentPerson);

    formApi.reset(formValues);
    dispatch(setContactsIsEdit(false));
  };

  const resetNewPerson = () => {
    dispatch(setCurrentPerson(null));
    dispatch(setContactsIsEdit(false));

    navigate(appRouterPaths.contacts.base);
  };

  const cancelHandler = () => {
    const onCancel = isNewPerson ? resetNewPerson : resetForm;

    const withConfirm = executeWithConfirm(onCancel);

    withConfirm();
  };

  const editHandler = () => {
    dispatch(setContactsIsEdit(true));
  };

  useEffect(() => {
    if (!isEdit) {
      resetForm();
    }
  }, []);

  return {
    cancelHandler,
    editHandler,
    isEdit,
  };
};
